import { useQuery } from '@tanstack/react-query';
import axiosInstance, { getAPIURL } from '../axiosInstance';

interface UseGetNotificationProps {
  id: number;
  enabled?: boolean;
}

export function useGetUserNotification({ id, enabled = true }: UseGetNotificationProps) {
  return useQuery({
    enabled,
    queryKey: ['notification', id],
    queryFn: async () => {
      return axiosInstance<Notification>(getAPIURL(`/Notification/${id}/Notifications`)).then(
        (response) => response.data,
      );
    },
  });
}